export const CallIcon = ({ color }: { color: string }) => {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15918_51265)">
        <path
          d="M15.04 13C15.1 13.89 15.25 14.76 15.49 15.59L14.29 16.79C13.88 15.59 13.62 14.32 13.53 13H15.04ZM24.9 25.02C25.75 25.26 26.62 25.41 27.5 25.47V26.96C26.18 26.87 24.91 26.61 23.7 26.21L24.9 25.02ZM16 11H12.5C11.95 11 11.5 11.45 11.5 12C11.5 21.39 19.11 29 28.5 29C29.05 29 29.5 28.55 29.5 28V24.51C29.5 23.96 29.05 23.51 28.5 23.51C27.26 23.51 26.05 23.31 24.93 22.94C24.83 22.9 24.72 22.89 24.62 22.89C24.36 22.89 24.11 22.99 23.91 23.18L21.71 25.38C18.88 23.93 16.56 21.62 15.12 18.79L17.32 16.59C17.6 16.31 17.68 15.92 17.57 15.57C17.2 14.45 17 13.25 17 12C17 11.45 16.55 11 16 11Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15918_51265">
          <rect width="24" height="24" fill="white" transform="translate(8.5 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};
